/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class PathologyApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `PathologyModule.forRoot()`
 */
export interface PathologyApiConfigurationParams {
  rootUrl?: string;
}
